import { useEffect, useState } from 'react';
import { ProductType, SavingsCalculatorStateType } from '../types';

export const useSavingsCalculator = ({
    years,
    startAmount,
    monthlyDeposit,
    chosenProduct = null,
    annualInterestRate = null,
}: SavingsCalculatorStateType & { chosenProduct: ProductType | null }) => {
    const [savingsCalculatorState, setSavingsCalculatorState] = useState<SavingsCalculatorStateType>({
        years,
        startAmount,
        monthlyDeposit,
        annualInterestRate,
        customInterestRate: '',
    });

    const updateSavingsCalculatorState = (state: Partial<SavingsCalculatorStateType>) => setSavingsCalculatorState(prev => ({ ...prev, ...state }));

    useEffect(() => {
        if (!chosenProduct?.interest?.rate) {
            return;
        }

        setSavingsCalculatorState(prev => ({
            ...prev,
            annualInterestRate: chosenProduct.interest.rate,
        }));
    }, [chosenProduct]);

    return {
        savingsCalculatorState,
        updateSavingsCalculatorState,
    };
};
